module.exports = __webpack_public_path__ + "static/media/project3.06bee17c.png";